import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkTranslation, translate } from '../../utils/useful'

export default class SettingFrame extends Component {
    state = {
        collapses: {},
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? false : !this.state.collapses[key]
        this.setState({ collapses })
    }



    render() {
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: '#fff' }}>{checkTranslation(this.props.currentFrame?.name) ?? translate('Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <button onClick={() => this.props.changePage('')} className='flexc w-100 p-2 hover-gray2 br-5 mb-2' >
                                        <div className="flexc">
                                            <img className="transition" src={'/images/icons/gaming-video.png'} height={18} />
                                            <div className='d-flex flex-column mld-3'>
                                                <p className={'font-size-12 weight-500 main-c3'}>{translate("Dashboard")}</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>

                                {Array.isArray(this.props.settingsSections) && this.props.settingsSections?.map((section, i) => {
                                    console.log('settingsection', section)
                                    return (
                                        <div className="w-100 pt-2 bb-gray">

                                            <button className="flexcb w-100 p-2 hover-gray br-5" onClick={() => this.changeCollapse(section.key)}>
                                                <div className="flexc">
                                                    <p className="font-size-12 weight-500 main-c3 " style={{}}>{checkTranslation(section.name)}</p>
                                                </div>
                                                <div className="">
                                                    <img className={"transition flexcc " + ((this.state.collapses[section.key] == null || this.state.collapses[section.key] == true) ? "" : "rotate-180")} width={18} src='/assets/icons/arrow-up-gray.svg' />
                                                </div>
                                            </button>


                                            <Collapsible open={this.state.collapses[section.key] == null ? true : this.state.collapses[section.key]}>
                                                <div className=''>
                                                    {this.props.settings.map((item, index) => {
                                                        if (section.key == item.section)
                                                            return (
                                                                <div className='w-100' key={index}>
                                                                    <button onClick={() => this.props.changePage(item)} className='flexc w-100 p-2 hover-gray br-5 transition-all'>
                                                                        <div className='flexcc'>
                                                                            <img className="transition-all" src={item.icon} height={22} />
                                                                        </div>
                                                                        <div className='mld-3'>
                                                                            <p className='font-size-12 main-c3 '>{checkTranslation(item.title)}</p>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            )
                                                    })}
                                                </div>
                                            </Collapsible>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
